module.exports = __webpack_public_path__ + "media/images/promotions/cards/chance-nothing-d433dc4cb866658c824708f875143b22.svg";